var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDraftFill = function SvgDraftFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.025 1.6 8.025 4.8q.45.274.7.75.25.475.25 1V19q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19V8.15q0-.525.25-1 .25-.476.7-.75l8.025-4.8A2 2 0 0 1 12 1.325q.55 0 1.025.275M12 12.65 19.8 8 12 3.35 4.2 8z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDraftFill);
export { ForwardRef as ReactComponent };